'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function DKFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-6oqxav4xt", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-i75cpl1h0", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-vlobcxr88" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-vlobcxr88", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-6oqxav4xt)" }, /* @__PURE__ */ React.createElement("use", { fill: "#c51918", xlinkHref: "#mantine-vlobcxr88" }), /* @__PURE__ */ React.createElement("g", { fill: "#f7fcff", mask: "url(#mantine-i75cpl1h0)" }, /* @__PURE__ */ React.createElement("path", { d: "M10 0h4v10h18v4H14v10h-4V14H0v-4h10z" }))))
  );
}

export { DKFlag };
//# sourceMappingURL=DK.mjs.map
